/**
 * When a signed-in user lands on a module they cannot open, the
 * AccessDenied screen parks them on a dead end.  Profile (``/me``) is
 * always reachable — it is not gated by ``RequirePermission`` — so we
 * send them there after a short pause instead of leaving them stuck.
 *
 * 404s (``not-found``) stay put: those are a missing URL, not a
 * missing module grant.
 *
 * ``PROFILE_REDIRECT_PATH`` must stay identical to ``ROUTES.PROFILE``
 * in ``config.js``.
 */

export const PROFILE_REDIRECT_SECONDS = 10;

export const PROFILE_REDIRECT_PATH = '/me';

export const PROFILE_REDIRECT_REASONS = Object.freeze([
  'unauthorized',
  'not-for-superadmin',
  'not-for-admin',
]);

export function shouldRedirectToProfile(reason) {
  return PROFILE_REDIRECT_REASONS.includes(reason);
}

/**
 * Copy shown under the access-denied explanation.  Counts down so the
 * user can see the wait is real; the initial value is the product
 * sentence "This page will redirect after 10 seconds."
 */
export function profileRedirectMessage(secondsLeft) {
  const n = Math.max(0, Number(secondsLeft));
  if (!Number.isFinite(n)) {
    return `This page will redirect after ${PROFILE_REDIRECT_SECONDS} seconds.`;
  }
  if (n === 1) return 'This page will redirect after 1 second.';
  return `This page will redirect after ${n} seconds.`;
}
